import { defineNuxtPlugin } from '#app'
import UI from '@monorepo/ui'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(UI)
})
